export interface AppointmentMixItem {
  group: string;
  label: string;
  minutes: number;
  pct: number;
}

export interface AppointmentGroupItem {
  group: string;
  minutes: number;
  pct: number;
  types: AppointmentMixItem[];
}

export interface ComputedMetrics {
  dvmDays: number;
  dvmHours: number;
  avgHoursPerDay: number;
  avgHoursPerWeekTotal: number;
  avgHoursPerDvmPerWeek: number;
  completeWeeksWorked: number;
  distinctDvms: number;
  distinctDates: number;
  dvmsPerDay: number;
  daysPerDvmPerWeek: number;
  totalScheduledMin: number;
  // Actual time worked, the Utilization denominator. dvmHours/avgHoursPerDay
  // remain the ROSTER figures, which is what the Capacity tab reports.
  totalWorkedMin: number;
  workedHours: number;
  avgWorkedHoursPerDay: number;
  totalBlockoffMin: number;
  totalSeenMin: number;
  totalOtherTypesMin: number;
  totalAvailMin: number;
  blockoffRate: number;
  petSeenRate: number;
  otherTypesRate: number;
  availableTimeRate: number;
  multiBookedPct: number;
  totalCompleted: number;
  avgCompletedPerDay: number;
  totalCanceled: number;
  avgBookingLeadTimeDays: number | null;
  appointmentMix: AppointmentMixItem[];
  appointmentGroupMix: AppointmentGroupItem[];
  avgSeenHoursPerDvmPerDay: number;
  avgOtherTypesHoursPerDvmPerDay: number;
  avgAvailHoursPerDvmPerDay: number;
  avgBlockoffHoursPerDvmPerDay: number;
  avgDvmDaysPerWeek: number;
}

export const EMPTY_METRICS: ComputedMetrics = {
  dvmDays: 0,
  dvmHours: 0,
  avgHoursPerDay: 0,
  avgHoursPerWeekTotal: 0,
  avgHoursPerDvmPerWeek: 0,
  completeWeeksWorked: 0,
  distinctDvms: 0,
  distinctDates: 0,
  dvmsPerDay: 0,
  daysPerDvmPerWeek: 0,
  totalScheduledMin: 0,
  totalWorkedMin: 0,
  workedHours: 0,
  avgWorkedHoursPerDay: 0,
  totalBlockoffMin: 0,
  totalSeenMin: 0,
  totalOtherTypesMin: 0,
  totalAvailMin: 0,
  blockoffRate: 0,
  petSeenRate: 0,
  otherTypesRate: 0,
  availableTimeRate: 0,
  multiBookedPct: 0,
  totalCompleted: 0,
  avgCompletedPerDay: 0,
  totalCanceled: 0,
  avgBookingLeadTimeDays: null,
  appointmentMix: [],
  appointmentGroupMix: [],
  avgSeenHoursPerDvmPerDay: 0,
  avgOtherTypesHoursPerDvmPerDay: 0,
  avgAvailHoursPerDvmPerDay: 0,
  avgBlockoffHoursPerDvmPerDay: 0,
  avgDvmDaysPerWeek: 0,
};
